import React, { Component } from "react";
import {
	Modal,
	Button,
	Alert,
	Grid,
	Row,
	Col,
	Checkbox,
} from "react-bootstrap";
import PropTypes from "prop-types";
import keyMirror from "keymirror";
import moment from "moment";
import TableUtils from "../../../../../../utils/TableUtils";
import lstrings from "../../../../../../utils/LStrings";
import PdfDoc from "../../../../../../utils/PdfDoc";
import PdfUtils from "../../../../../../utils/PdfUtils";
import Session from "../../../../../../utils/Session";
import "./CrearPDF.css";

export const CrearPDFTIPODIALOGO = keyMirror({
	descargar: null,
	imprimir: null,
});

class CrearPDF extends Component {
	constructor(props) {
		super(props);

		this.state = {
			mostrarAlertPopup: false,
			checkboxs: {
				todos: true,
				veraz: true,
				datosparticulares: true,
				datoslaborales: true,
				impuesto: true,
				vinculos: true,
				participacionsocietaria: true,
				boletinoficial: true,
				contactacion: true,
				bienespersonales: true,
				situacionFinanciera: true,
			},
			alert_text: "",
		};
	}

	imprimir = () => {
		// var docDefinition = { content: 'This is an sample PDF printed with pdfMake' };
		// pdfMake.createPdf(docDefinition).download("algo.pdf");
		// pdfMake.createPdf(docDefinition).open();
		// pdfMake.createPdf(docDefinition).print();

		// crea un chunk de js a traves de webpack para solo cargar pdfmake en caso de que se quiera imprimir
		let cpdf = null;
		require.ensure("./cpdf", () => {
			cpdf = require("./cpdf").default;

			let fechaHora = this.props.fecha.format("YYYY-MM-DD_HH-mm");
			this.procesarDatos().then((docDefinition) => {
				try {
					// cpdf.createPdf(docDefinition).open();
					if (
						this.props.tipodialogo === CrearPDFTIPODIALOGO.imprimir
					) {
						cpdf.createPdf(docDefinition).print();
					} else {
						cpdf.createPdf(docDefinition).download(
							`${this.props.info.datosParticulares.cuil}_${fechaHora}.pdf`
						);
					}
					this.props.onCerrarPDF();
				} catch (error) {
					this.setState({
						alert_text: error,
						mostrarAlertPopup: true,
					});
				}
			});
		});
	};

	procesarDatos = async () => {
		const doc = new PdfDoc();

		// Header
		const dp = this.props.info.datosParticulares;
		await PdfUtils.header(
			doc,
			dp.apellidoNombre,
			dp.cuil,
			dp.sujetoObligado ? dp.sujetoObligado.habilitado : false,
			this.props.info.idLog,
			this.props.info.codigo,
			this.props.fecha.format("DD/MM/YYYY HH:mm"),
			dp.scoreAgdEnabled ? dp.score : undefined,
			dp.scoreAgdEnabled ? dp.puntaje : undefined,
			this.props.consultasPorRubro
		);

		// Veraz
		if (
			this.props.showPanels.panelVeraz &&
			(this.state.checkboxs.todos || this.state.checkboxs.veraz)
		) {
			const dv = this.props.info.veraz;
			// Solo muestro la información si la respuesta está OK
			if (true) {
				console.log(this.props.info.situacionFinanciera);
				console.log(this.props.info.morosidad);
				doc.addText(lstrings.panelVerazTitle, "subheader");
				doc.addEmptyLine();

				// Veraz no puede mostrar información
				if (dv.categoria != undefined) {
					const headerCols = {
						columns: [
							{
								height: 40,
								width: "*",
								text: dv.mensaje,
								style: "columnCentered",
							},
						],
					};
					doc.addRawDef(headerCols);
				}
				// Se muestra la info recibida
				else {
					let pje = parseInt(dv.scoreRango, 10);
					if (!Number.isInteger(pje)) {
						pje = -1;
					}

					let scoreSvg = null;
					if (pje > 0 && pje <= 5) {
						scoreSvg = await fetch(
							`/score-graphics/S${pje}.svg`
						).then((data) => data.text());
					} else {
						scoreSvg = await fetch(
							`/score-graphics/no-score.svg`
						).then((data) => data.text());
					}
					let scoreGraphicCol = {
						svg: scoreSvg,
						height: 40,
						width: 120,
						margin: [0, 20, 0, 0],
					};

					let incomeCol = null;
					if (dv.incomePredictor) {
						const incomeSvg = await fetch(
							`/income-graphics/I${dv.incomePredictor}.svg`
						).then((data) => data.text());
						incomeCol = {
							svg: incomeSvg,
							height: 96,
							width: 92,
							margin: [10, 0, 0, 0],
						};
					}

					const headerCols = {
						columns: [
							{
								height: 40,
								width: 20,
								text: "",
							},
							{
								height: 40,
								width: 130,
								text: `${dv.scoreExplanation}`,
								style: "columnCentered",
								margin: [0, 30, 0, 0],
							},
							scoreGraphicCol,
							incomeCol,
							{
								height: 40,
								width: 150,
								text: `${dv.incomePredictorRango}`,
								style: "columnCentered",
								margin: [15, 40, 0, 0],
							},
							{
								height: 40,
								width: 40,
								text: "",
							},
						],
					};
					doc.addRawDef(headerCols);

					if (dv.cantObsVigBa24m != undefined) {
						const headers = [
							lstrings.fecha,
							lstrings.verazObsInformanteTitle,
							lstrings.monto,
						];

						const data = dv.obsVigentesBa.map((obs) => {
							return [
								TableUtils.dateFormat(obs.fecha),
								obs.nombreEntidad,
								TableUtils.ARSFormat(obs.monto, false, false),
							];
						});

						const widths = ["*", "*", "*"];
						doc.addSimpleTable(
							lstrings.verazObsTitle,
							headers,
							data,
							widths
						);
					}
				}
			}
		}

		// Tabla Nodo Federal
		if (process.env.REACT_APP_FLAVOR === "reseller") {
			if (this.props.info.morosidad.deudoresCentroComercial != null) {
				const dmcc =
					this.props.info.morosidad.deudoresCentroComercial.datos;
				const dmcc_h = [
					lstrings.fecha_deuda,
					lstrings.monto,
					lstrings.informador,
					lstrings.origenDeuda,
					lstrings.estadoDeuda,
					lstrings.tipoDeudor,
				];

				const dmcc_d = dmcc.map((info) => {
					return [
						TableUtils.dateFormat(info.fechaDeAtraso),
						TableUtils.ARSFormat(info.deudaTotal),
						info.nombreInstituto,
						info.nombreSocio,
						info.codDeEstado,
						info.tipoDeudor,
					];
				});

				const dmcc_w = ["14%", "*", "25%", "25%", "15%", "10%"];

				doc.addSimpleTableSubtitle(
					lstrings.denuncias_nodoFederal,
					lstrings.verazObsDescription,
					dmcc_h,
					dmcc_d,
					dmcc_w
				);
			}
		}

		// Datos particulares
		if (
			this.props.showPanels.panelDatosParticulares &&
			(this.state.checkboxs.todos ||
				this.state.checkboxs.datosparticulares)
		) {
			doc.addText(lstrings.datosparticulares_title, "subheader");

			const datp_h = [
				"Cuit / Cuil",
				"Nro DNI",
				"Versión DNI",
				"Nacionalidad",
				"Año",
				"Fecha Nacimiento",
				"Fecha Defunción",
				"Edad",
				"Sexo",
			];
			const datp_d = [
				[
					dp.cuil,
					dp.dni,
					dp.tipo,
					TableUtils.stringFormat(dp.nacionalidad),
					dp.anio,
					TableUtils.dateFormat(dp.fechaNacimiento),
					dp.fechaDeceso
						? doc.createText(
								TableUtils.dateFormat(dp.fechaDeceso),
								"dtRed"
						  )
						: TableUtils.dateFormat(dp.fechaDeceso),
					dp.edad,
					dp.sexo,
				],
			];
			const datp_w = ["*", "*", "*", "*", 20, "*", "*", 20, 20];
			doc.addSimpleTable(lstrings.general_title, datp_h, datp_d, datp_w);

			const dom = [
				this.props.info.datosParticulares.domicilio,
				this.props.info.datosParticulares.cp,
				this.props.info.datosParticulares.localidad,
				this.props.info.datosParticulares.provincia,
			];
			doc.addSimpleTable(
				lstrings.domicilioparticular_title,
				[
					lstrings.ubicacion,
					lstrings.cp,
					lstrings.localidad,
					lstrings.provincia,
				],
				[dom]
			);

			if (dp.domAlternativos) {
				const alt_dom = dp.domAlternativos.datos.map((dom) => {
					return [
						dom.domicilioAlt,
						dom.cpAlt,
						dom.localidadAlt,
						dom.provinciaAlt,
					];
				});
				doc.addSimpleTable(
					lstrings.otrosdomicilios_title,
					[
						lstrings.ubicacion,
						lstrings.cp,
						lstrings.localidad,
						lstrings.provincia,
					],
					alt_dom
				);
			}
		}

		// Contactación
		if (
			this.props.showPanels.panelContactacion &&
			(this.state.checkboxs.todos || this.state.checkboxs.contactacion)
		) {
			PdfUtils.panelContactacion(
				doc,
				this.props.info.telefonos,
				this.props.info.telefonosAdicionales,
				this.props.info.telefonosCelulares,
				this.props.info.datosParticulares.mails
			);
		}

		// Datos Laborales
		if (
			this.props.showPanels.panelDatosLaborales &&
			(this.state.checkboxs.todos || this.state.checkboxs.datoslaborales)
		) {
			doc.addText(lstrings.datoslaborales_title, "subheader");

			const dls = this.props.info.datosLaborales;
			const dl = dls.datoLaboral ? dls.datoLaboral.datos : null;
			if (dl) {
				let dl_h = [
					lstrings.estado,
					lstrings.cuit,
					lstrings.razonsocial,
					lstrings.periodoUltimo,
				];
				let dl_d = [];
				let dl_w = ["10%", "13%", "*", "20%"];

				if (!Session.getUser().isDisa) {
					dl_h.push(lstrings.nivelIngreso);
					dl_w.push("15%");
				}

				const dl_deh = ["Actividad Empleador", "Cant. Empleados"];
				let dl_ded = [];
				const dl_deh_w = ["75%", "25%"];

				dl.forEach((datos) => {
					let fa = moment(datos.relacionDependencia.alta).format(
						"DD/MM/YYYY"
					);
					let fb = datos.relacionDependencia.baja
						? moment(datos.relacionDependencia.baja).format(
								"DD/MM/YYYY"
						  )
						: "";
					let fc = `${fa} - ${fb}`;

					let rowData = [
						doc.createText(
							datos.relacionDependencia.estado,
							this.setColorEstadoLaboral(
								datos.relacionDependencia.estado
							)
						),
						datos.relacionDependencia.cuit,
						datos.relacionDependencia.razonSocial,
						fc,
					];
					if (!Session.getUser().isDisa) {
						rowData.push(
							datos.relacionDependencia.sueldo
								? datos.relacionDependencia.sueldo
								: ""
						);
					}

					dl_d.push(rowData);

					//si esto es un array, ajustar
					dl_ded.push([
						TableUtils.stringFormat(
							datos.historialSueldo.infoAdicionalEmpleador
								.actividadempleador
						),
						datos.historialSueldo.infoAdicionalEmpleador
							.cantidadempleados
							? TableUtils.formatearNumeroEntero(
									datos.historialSueldo.infoAdicionalEmpleador
										.cantidadempleados
							  )
							: "-",
					]);
				}, this);

				const dlt = doc.createSimpleTable(dl_h, dl_d, dl_w);
				let ted = {};
				// inyecto las subtablas en orden invertido para que la logica sea mas clara
				for (var i = dl.length; i > 0; i--) {
					ted = doc.createSimpleTable(
						dl_deh,
						[dl_ded[i - 1]],
						dl_deh_w
					);
					dlt.table.body.splice(i + 1, 0, [
						{
							colSpan: dl_h.length,
							table: ted.table,
						},
					]);
				}

				doc.addText(lstrings.relaciondependencia_title, "tableTitle");
				doc.addRawDef(dlt);
			}

			// Jubilación
			PdfUtils.tableJubilaciones(doc, dls.jubilacion);

			// Autónomo o Monotributista
			if (dls.monotributista) {
				const dlm = dls.monotributista.datos;
				const dlm_h = [
					lstrings.fecha_inicio,
					lstrings.fechahasta,
					lstrings.tipo,
					lstrings.categoria,
					lstrings.ganancias,
					lstrings.iva,
					lstrings.integrasociedades,
				];
				const dlm_d = dlm.map((info) => {
					return [
						TableUtils.dateFormat(info.fechaInicio),
						TableUtils.dateFormat(info.fechaHasta),
						info.tipo,
						info.categoria,
						info.ganancias,
						info.iva,
						info.integrasociedades,
					];
				});

				doc.addSimpleTable(lstrings.autonomo_title, dlm_h, dlm_d);
			}

			// Aportes Autónomo / Monotributo
			if (dls.aportesAM && dls.aportesAM.datos.length) {
				PdfUtils.tableAportes(
					doc,
					dls.aportesAM.datos,
					lstrings.aportesAutonomoMonotributo_title
				);
			}

			// Actividades
			PdfUtils.tableActividad(doc, dls.actividad);

			// Obra Social
			if (dls.obraSocial) {
				const dlos = dls.obraSocial.datos;
				const dlos_h = [lstrings.codigo, lstrings.descripcion_title];
				const dlos_d = dlos.map((info) => {
					return [info.codigo, info.descripcion];
				});
				doc.addSimpleTable(lstrings.obrasocial_title, dlos_h, dlos_d);
			}

			// Cantidad de empleados que registran aportes (por año)
			if (dls.empAportes && dls.empAportes.datos.length) {
				PdfUtils.tableEmpAportes(doc, dls.empAportes, false);
			}

			// Sueldos cobrados
			if (dls.sueldos && dls.sueldos.datos.length) {
				PdfUtils.tableSueldosCobrados(doc, dls.sueldos);
			}

			// Empleados domésticos
			const dged_w = ["25%", "10%", "10%", "*", "10%"];
			if (dls.empDomesticos && dls.empDomesticos.datos.length) {
				const dged = dls.empDomesticos.datos;
				const dged_h = [
					lstrings.empleador,
					lstrings.cuil,
					lstrings.periodo,
					lstrings.modoliquidacion,
					lstrings.aporte,
				];
				const dged_d = dged.map((item) => {
					return [
						item.nombreEmpleador,
						item.cuilEmpleador,
						TableUtils.dateFormat(item.periodo),
						item.detalle,
						TableUtils.ARSFormat(item.aporte),
					];
				});
				doc.addSimpleTable(
					lstrings.domesticosEmpleadosTitle,
					dged_h,
					dged_d,
					dged_w
				);
			}

			// Empleadores domésticos
			if (dls.domEmpleadores && dls.domEmpleadores.datos.length) {
				const dged = dls.domEmpleadores.datos;
				const dged_h = [
					lstrings.empleado,
					lstrings.cuil,
					lstrings.periodo,
					lstrings.modoliquidacion,
					lstrings.aporte,
				];
				const dged_d = dged.map((item) => {
					return [
						item.nombreEmpleado,
						item.cuilEmpleado,
						TableUtils.dateFormat(item.periodo),
						item.detalle,
						TableUtils.ARSFormat(item.aporte),
					];
				});
				doc.addSimpleTable(
					lstrings.domesticosEmpleadorTitle,
					dged_h,
					dged_d,
					dged_w
				);
			}

			// Aportes empleados servicio doméstico
			if (dls.domAportes && dls.domAportes.datos.length) {
				PdfUtils.tableAportes(
					doc,
					dls.domAportes.datos,
					lstrings.aportesServDomestico_title
				);
			}

			//seg social
			if (dls.seguridadSocial && dls.seguridadSocial.datos.length) {
				PdfUtils.tableSegSocial(doc, dls.seguridadSocial);
			}
		}

		// Impuestos
		if (
			this.props.showPanels.panelImpuestos &&
			(this.state.checkboxs.todos || this.state.checkboxs.impuesto)
		) {
			doc.addText(lstrings.impuesto_title, "subheader");
			PdfUtils.tableImpuestos(doc, this.props.info.pagosImpuestos);
		}

		// Vínculos
		if (
			this.props.showPanels.panelVinculos &&
			(this.state.checkboxs.todos || this.state.checkboxs.vinculos)
		) {
			doc.addText(lstrings.vinculos_title, "subheader");

			const dv = this.props.info.vinculos;
			if (dv.vinculos) {
				const dvv = dv.vinculos.datos;
				const dvv_h = ["DNI/CUIT", "Nombre", "Parentesco", "Sexo"];
				const dvv_d = dvv.map((info) => {
					return [
						info.cuilVinculo,
						info.nombre,
						info.relacion,
						info.sexo,
					];
				});
				doc.addSimpleTable(lstrings.vinculosfam_title, dvv_h, dvv_d);
			}

			if (dv.otrosVinculos) {
				const dvov = dv.otrosVinculos.datos;
				const dvov_h = ["DNI/CUIT", "Nombre"];
				const dvov_d = dvov.map((info) => {
					return [info.cuilvinculo, info.nombre];
				});
				doc.addSimpleTable(
					lstrings.vinculosotros_title,
					dvov_h,
					dvov_d,
					["auto", "*"]
				);
			}
		}

		// Bienes Personales
		if (
			this.props.showPanels.panelBienesPersonales &&
			(this.state.checkboxs.todos ||
				this.state.checkboxs.bienespersonales)
		) {
			doc.addText(lstrings.bienespersonales_title, "subheader");
			const dbp = this.props.info.bienesPersonales;
			PdfUtils.panelBienes(
				doc,
				dbp.propiedades,
				dbp.automotores,
				dbp.automotores_historial,
				dbp.autosembargos
			);
		}

		// Situación Financiera
		if (
			this.props.showPanels.panelSituacionFinanciera &&
			(this.state.checkboxs.todos ||
				this.state.checkboxs.situacionFinanciera)
		) {
			PdfUtils.panelSituacionFinanciera(
				doc,
				this.props.info.situacionFinanciera,
				this.props.info.morosidad
			);
		}

		// Boletín Oficial
		if (
			this.props.showPanels.panelBoletinOficial &&
			(this.state.checkboxs.todos || this.state.checkboxs.boletinoficial)
		) {
			doc.addText(lstrings.boletinoficial_title, "subheader");
			const participacionSocietaria =
				this.props.info.participacionSocietaria;
			const boletinOficial = this.props.info.boletinOficial;

			PdfUtils.tableParteSociedad(
				doc,
				participacionSocietaria,
				boletinOficial
			);
		}

		doc.addEmptyLine(3);

		let disclaimer = lstrings.disclaimer_pdf;
		doc.addText(disclaimer);

		return doc.getDoc();
	};

	/**
	 * Formateo basico para headers de tablas
	 *
	 * @param {Array} headers array de strings
	 * @returns {Array} array de objetos formateados
	 */
	setupTableHeaders(headers) {
		return headers.map((h) => {
			return {
				text: h,
				style: "tableHeader",
			};
		});
	}

	handleCbChange = (e) => {
		var st = this.state.checkboxs;
		st[e.target.id] = !st[e.target.id];
		if (e.target.id === "todos") {
		}
		this.setState({
			checkboxs: st,
		});
	};

	/**
	 * Selecciona el estilo correspondiente, según el estado
	 */
	setColorEstadoLaboral = (estado) => {
		let textColor;
		switch (estado) {
			case "Activo":
				textColor = "dtGreen";
				break;

			case "Inactivo":
				textColor = "dtRed";
				break;

			default:
				textColor = "dt";
		}

		return textColor;
	};

	render() {
		let boton_text =
			this.props.tipodialogo === CrearPDFTIPODIALOGO.imprimir
				? lstrings.imprimir
				: lstrings.descargar;
		let titulo =
			this.props.tipodialogo === CrearPDFTIPODIALOGO.imprimir ? (
				<h2 className="modal-title-fa">
					<i className="fa fa-print" aria-hidden="true"></i>
					{lstrings.imprimir}
				</h2>
			) : (
				<h2 className="modal-title-fa">
					<i className="fa fa-file-pdf-o" aria-hidden="true"></i>
					{lstrings.descargarPdf}
				</h2>
			);

		return (
			<div>
				<Modal
					show={this.props.mostrarPDF}
					onHide={this.props.onCerrarPDF}
				>
					<Modal.Header closeButton>
						<Modal.Title>{titulo}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<h5>Seleccione las secciones que desea usar:</h5>
						<Grid fluid>
							<Row>
								<Col sm={12}>
									<Checkbox
										id="todos"
										checked={this.state.checkboxs.todos}
										onChange={this.handleCbChange}
									>
										Todas las secciones
									</Checkbox>
								</Col>

								{this.props.showPanels.panelVeraz && (
									<Col sm={6}>
										<Checkbox
											id="veraz"
											checked={this.state.checkboxs.veraz}
											onChange={this.handleCbChange}
											disabled={
												this.state.checkboxs.todos
											}
										>
											{lstrings.panelVerazTitle}
										</Checkbox>
									</Col>
								)}
								{this.props.showPanels
									.panelDatosParticulares && (
									<Col sm={6}>
										<Checkbox
											id="datosparticulares"
											checked={
												this.state.checkboxs
													.datosparticulares
											}
											onChange={this.handleCbChange}
											disabled={
												this.state.checkboxs.todos
											}
										>
											{lstrings.datosparticulares_title}
										</Checkbox>
									</Col>
								)}
								{this.props.showPanels.panelContactacion && (
									<Col sm={6}>
										<Checkbox
											id="contactacion"
											checked={
												this.state.checkboxs
													.contactacion
											}
											onChange={this.handleCbChange}
											disabled={
												this.state.checkboxs.todos
											}
										>
											{lstrings.contactacion_title}
										</Checkbox>
									</Col>
								)}
								{this.props.showPanels.panelDatosLaborales && (
									<Col sm={6}>
										<Checkbox
											id="datoslaborales"
											checked={
												this.state.checkboxs
													.datoslaborales
											}
											onChange={this.handleCbChange}
											disabled={
												this.state.checkboxs.todos
											}
										>
											{lstrings.datoslaborales_title}
										</Checkbox>
									</Col>
								)}
								{this.props.showPanels.panelImpuestos && (
									<Col sm={6}>
										<Checkbox
											id="impuesto"
											checked={
												this.state.checkboxs.impuesto
											}
											onChange={this.handleCbChange}
											disabled={
												this.state.checkboxs.todos
											}
										>
											{lstrings.impuesto_title}
										</Checkbox>
									</Col>
								)}
								{this.props.showPanels.panelVinculos && (
									<Col sm={6}>
										<Checkbox
											id="vinculos"
											checked={
												this.state.checkboxs.vinculos
											}
											onChange={this.handleCbChange}
											disabled={
												this.state.checkboxs.todos
											}
										>
											{lstrings.vinculos_title}
										</Checkbox>
									</Col>
								)}
								{this.props.showPanels
									.panelBienesPersonales && (
									<Col sm={6}>
										<Checkbox
											id="bienespersonales"
											checked={
												this.state.checkboxs
													.bienespersonales
											}
											onChange={this.handleCbChange}
											disabled={
												this.state.checkboxs.todos
											}
										>
											{lstrings.bienes_title}
										</Checkbox>
									</Col>
								)}
								{this.props.showPanels
									.panelSituacionFinanciera && (
									<Col sm={6}>
										<Checkbox
											id="situacionFinanciera"
											checked={
												this.state.checkboxs
													.situacionFinanciera
											}
											onChange={this.handleCbChange}
											disabled={
												this.state.checkboxs.todos
											}
										>
											{lstrings.situacionFinanciera_title}
										</Checkbox>
									</Col>
								)}
								{this.props.showPanels.panelBoletinOficial && (
									<Col sm={6}>
										<Checkbox
											id="boletinoficial"
											checked={
												this.state.checkboxs
													.boletinoficial
											}
											onChange={this.handleCbChange}
											disabled={
												this.state.checkboxs.todos
											}
										>
											{lstrings.boletinoficial_title}
										</Checkbox>
									</Col>
								)}
							</Row>
						</Grid>

						{this.state.mostrarAlertPopup && (
							<Alert bsStyle="warning">
								{"Mensaje para que se permitan popups " +
									this.state.alert_text}
							</Alert>
						)}
						<div className="cpdf-toolbar">
							<Button onClick={this.imprimir} bsStyle="primary">
								{boton_text}
							</Button>
							<Button
								onClick={this.props.onCerrarPDF}
								bsStyle="secondary"
							>
								{lstrings.cerrar}
							</Button>
						</div>
					</Modal.Body>
				</Modal>
			</div>
		);
	}
}

CrearPDF.propTypes = {
	mostrarPDF: PropTypes.bool,
	onCerrarPDF: PropTypes.func,
	info: PropTypes.object,
	consultasPorRubro: PropTypes.object,
	fecha: PropTypes.object,
	tipodialogo: PropTypes.string,
	showPanels: PropTypes.object,
};

export default CrearPDF;



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/pdf/CrearPDF.js